import { useQuery } from '@tanstack/react-query'
import { apiGet, type PlatformSummary } from '../lib/api.ts'
import { StatTile } from '../components/StatTile.tsx'

export function Overview() {
  const { data, isPending, error } = useQuery({
    queryKey: ['summary'],
    queryFn: () => apiGet<PlatformSummary>('/summary'),
  })

  return (
    <div>
      <h1 className="text-xl font-semibold tracking-tight">Overview</h1>
      <p className="mt-1 text-sm text-ink-muted">
        Canonical layer as of the most recent build.
      </p>

      {/*
        Every number on this page is synthetic. Saying so on the page itself is
        not decoration — CLAUDE.md warns that synthetic distributions predict
        nothing, and an unlabelled dashboard is exactly how that gets forgotten.
      */}
      <p className="mt-4 rounded-md border border-gold-500/40 bg-gold-500/10 px-3 py-2 text-sm text-ink">
        <span className="font-semibold">Synthetic data.</span> These counts exercise the
        pipeline. They predict nothing about real voter data.
      </p>

      {error ? (
        <p className="mt-6 rounded-md border border-line bg-surface-sunken px-3 py-2 text-sm">
          Could not load the summary: {error instanceof Error ? error.message : 'unknown error'}
        </p>
      ) : null}

      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        <StatTile label="Persons" value={isPending ? null : (data?.persons ?? null)} />
        <StatTile
          label="Current voters"
          value={isPending ? null : (data?.voters_current ?? null)}
          hint="present in latest file"
        />
        <StatTile
          label="Absent from file"
          value={isPending ? null : (data?.voters_absent ?? null)}
          hint="retained, never deleted"
        />
        <StatTile label="Households" value={isPending ? null : (data?.households ?? null)} />
        <StatTile label="Addresses" value={isPending ? null : (data?.addresses ?? null)} />
        <StatTile label="With a phone" value={isPending ? null : (data?.with_phone ?? null)} />
        <StatTile label="Elections" value={isPending ? null : (data?.elections ?? null)} />
        <StatTile
          label="Vote history rows"
          value={isPending ? null : (data?.vote_history_rows ?? null)}
        />
      </div>

      <p className="mt-4 text-xs text-ink-muted">
        Nonstandard addresses: {isPending ? '—' : (data?.nonstandard_address ?? 0)} · Latest
        extract: {data?.latest_extract_date ?? '—'}
      </p>
    </div>
  )
}
